import type { DropdownOption } from 'shared/models/dropdownOption'

export enum appWidth {
    max = '1584px',
}

export enum breakpoints {
    xs = 0,
    sm = 320,
    md = 672,
    lg = 1056,
    xl = 1312,
    max = 1584,
    maxplus = 1784,
}

export enum color {
    ALTBLACK = '#373737',
    TRUE_BLACK = '#000',
    BLACK = '#231F20',
    BLACK_RGBA = 'rgba(1, 1, 1, 0.38)',
    BLUE = '#039BE5',
    BLUEGRAY = '#F5F6FA',
    BLUEGRAY_RGBA = '245, 246, 250, 0.8',
    BACKGROUND = '#F3F5F7',
    CARDGRAY = '#DFDFDF',
    CARDBORDER = '#C8C8C8',
    DARKBLUE = '#037DBA',
    DARKERBLUE = '#00689B',
    DARKERGRAY = '#707070',
    DARKGRAY = '#333333',
    DARKGREEN = '#008566',
    DARKRED = '#E00000',
    DARKYELLOW = '#C39400',
    FUSCHIA = '#E91E63',
    GRAPHITE = '#505050',
    GRAY = '#E7E8EC',
    GRAY_PROGESS_BAR = '#D3D2D2',
    GRAY_RGBA = '0, 0, 0, 0.3',
    GREEN = '#00B288',
    GREEN_HABITS = '#019688',
    GREEN_HABITS_DARK = '#00776C',
    GREEN_HABITS_LIGHT = '#B3E0DB',
    ICON = '#F4F4F4',
    INDEX_BG = '#F4F4F4',
    INDEX_FOOTNOTE = '#646464',
    INTERACTIVE_03 = '#0F62FE',
    LIGHTBLUE = '#00BFF3',
    LIGHTERBLUE = '#F2FAFE',
    LIGHTERGRAY = '#B9B9B9',
    LIGHTGRAY = '#5F5F5F',
    LIGHTRED = '#FF5252',
    MUTEDGRAY = '#DFDFDF',
    PALEBLUE = '#EFF9FF',
    PALEGRAY = '#A4A4A4',
    PINK = '#FF7070',
    PROGRESSGRAY = '#d3d2d2',
    PURPLE = '#7B1FA2',
    RANK_YELLOW = '#FEEBB1',
    RED = '#E91E63',
    SLIDERGRAY = '#B9B9B9',
    SOFTBLUE = '#CDEBFA',
    LINK = '#186FD6',
    WHITE = '#FFF',
    YELLOW = '#FFCA28',
    DISABLED_02 = '#C6C6C6',
    INVERSE_SUPPORT_02 = '#4CAF50',
    PRIMARY_DARK = '#00456F',
    PRIMARY_LIGHT = '#007bc7',
    NAV_FOCUS = 'rgba(0, 0, 0, 0.12)',
}

export enum fontFamily {
    primary = 'Roboto, Helvetica, Arial, sans-serif',
    secondary = 'Mercury Display, mercury-display, sans-serif',
}

export enum fontSize {
    xsmall = '.75rem', // 12px
    small = '.875rem', // 14px
    normal = '1rem', // 16px
    medium = '1.25rem', // 20px
    large = '1.5rem', // 24px
    header = '2.25rem', // 36px
    xlarge = '2.625rem', // 42px
    xxlarge = '3rem', // 48px
}

export enum iconSizes {
    xsmall = '0.65rem',
    smaller = '1rem',
    xxsmall = '1.25rem', //20px
    small = '1.5rem',
    normal = '2rem',
    large = '2.5rem',
    xlarge = '3rem',
    xxlarge = '5rem',
    xxxlarge = '8rem',
}

export const emptyDropdownOption: DropdownOption = { id: '', value: '' }
export const defaultDropdownOptions = 10
export const getDropdownMaxHeight = (
    theme: any,
    optionsToShow: number = defaultDropdownOptions
) => {
    return parseFloat(theme.spacing(6)) * optionsToShow
}
